// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { TextField, Button, Container, Typography, Select, MenuItem, FormControl, InputLabel, Dialog } from "@mui/material";

// export default function AddItem({refetch}) {
//     const date = new Date().toISOString();
//     const [formData, setFormData] = useState({
//         service_id: "1",
//         // status: "unpaid",
//         unit_id: "",
//         // created_at: date,

//     });
//     console.log("Form data sented",formData)
//     const [units, setUnits] = useState([]);
//     const token = localStorage.getItem("token") || ""; // Get token from localStorage

//     // Fetch Units
//     useEffect(() => {
//         const fetchUnits = async () => {
//             try {
//                 const response = await axios.get("https://app.baskeg.com/api/v1/owners/units", {
//                     headers: { Authorization: `Bearer ${token}` },
//                 });
//                 setUnits(response.data.data);
//             } catch (error) {
//                 console.error("Error fetching units:", error);
//             }
//         };
//         if (token) fetchUnits();
//     }, [token]);

//     // Handle Input Change
//     const handleUnitChange = (event) => {
//         setFormData({ ...formData, unit_id: event.target.value , service_id:"2"});
//     };
//     // Handle Input Change
//     const handleServiceChange = (event) => {
//         setFormData({ ...formData, service_id: event.target.value});
//     };
    

//     // Handle Form Submission
//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             const response = await axios.post(
//                 "https://app.baskeg.com/api/v1/owners/maintenance",
//                 formData,
//                 { headers: { Authorization: `Bearer ${token}` } }
//             );
//             console.log("Response:", response.data);
//             // window.location.reload();
//         } catch (error) {
//             console.error("Error submitting request:", error);
//         }
//     };

//     return (
//         <Container maxWidth="sm" dir="ltr" >
//             <Typography variant="h5" sx={{ mb: 2 }}> Add Maintenance</Typography>
//             <form onSubmit={handleSubmit}>
//                 <FormControl fullWidth margin="normal">
//                     <InputLabel>Select Unit</InputLabel>
//                     <Select value={formData.unit_id} onChange={handleUnitChange}>
//                         {units.map((unit) => (
//                             <MenuItem key={unit.id} value={unit.id}>
//                                 {unit.name}
//                             </MenuItem>
//                         ))}
//                     </Select>
//                 </FormControl>
//                 {/* <FormControl fullWidth margin="normal">
//                     <InputLabel>Select Service</InputLabel>
//                     <Select value={formData.service_id} onChange={handleServiceChange}>
//                         {units.map((unit) => (
//                             <MenuItem key={unit.id} value={unit.id}>
//                                 {unit.name}
//                             </MenuItem>
//                         ))}
//                     </Select>
//                 </FormControl> */}
//                 <Button variant="contained" color="primary" type="submit" sx={{ mt: 2 }} disabled={!formData.unit_id}>
//                     Submit
//                 </Button>
//             </form>
//         </Container>
//     );
// }





import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, Container, Typography, Select, MenuItem, FormControl, InputLabel } from "@mui/material";

export default function AddItem({render , close}) {

    const [formData, setFormData] = useState({
        unit_id: "",
        service_id: "",
    });
    console.log("dsdsdasddasdaskjkjjnnnfdh",formData);

    const [units, setUnits] = useState([]);
    const [service, setService] = useState([]);
    const token = localStorage.getItem("token") || "";

    useEffect(() => {
        const fetchUnits = async () => {
            try {
                const response = await axios.get("https://app.baskeg.com/api/v1/owners/units", {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setUnits(response.data.data);
            } catch (error) {
                console.error("Error fetching units:", error);
            }
        };
        if (token) fetchUnits();
    }, [token]);

    useEffect(() => {
        const fetchService = async () => {
            try {
                const response = await axios.get("https://app.baskeg.com/api/v1/owners/maintenance-services", {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setService(response.data.data);
            } catch (error) {
                console.error("Error fetching units:", error);
            }
        };
        if (token) fetchService();
    }, [token]);

    const handleUnitChange = (event) => {
        setFormData({ ...formData, unit_id: event.target.value });
    };

    const handleServiceChange = (event) => {
        setFormData({ ...formData, service_id: event.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(formData)
        try {
            const response = await axios.post(
                "https://app.baskeg.com/api/v1/owners/maintenance",
                formData,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            console.log("Response:", response.data);
            render();
            close();
            // window.location.reload();
        } catch (error) {
            console.error("Error submitting request:", error);
        }
    };

    // const services = [
    //     { id: 1, value: "Maintenance" || ""},
    //     { id: 2, value: "House Keeping"|| ""},
    //     { id: 3, value: "House Keeping2"|| ""},
    //   ];

      

    return (
        <Container maxWidth="sm" dir="ltr" sx={{ backgroundColor: "var(--seco-col)", p:3 ,borderRadius: "10px",border:"none !important",boxShadow:"none"}}>
            <Typography variant="h5" sx={{ mb: 2, textAlign: "center", fontWeight: "bold", color: "#333" }}>
                Add Maintenance
            </Typography>
            <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                <FormControl fullWidth sx={{ border: "none", boxShadow: "none" }}>
                    <InputLabel shrink={false} sx={{ 
                        position: 'relative', 
                        transform: 'none',
                        marginBottom: '5px'
                    }}>Select Unit</InputLabel>
                    <Select
                        value={formData.unit_id}
                        onChange={handleUnitChange}
                        variant="outlined"
                        sx={{ backgroundColor: "white", borderRadius: "8px", border: "none", boxShadow: "none" }}
                    >
                        {units.map((unit) => (
                            <MenuItem key={unit.id} value={unit.id} dir="ltr">
                                {unit.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl fullWidth sx={{ border: "none", boxShadow: "none" }} dir="ltr">
                    <InputLabel shrink={false} sx={{ 
                        position: 'relative', 
                        transform: 'none',
                        marginBottom: '5px'
                    }}> Select Service </InputLabel>
                    <Select
                        value={formData.service_id}
                        onChange={handleServiceChange}
                        variant="outlined"
                        sx={{ backgroundColor: "white", borderRadius: "8px", border: "none", boxShadow: "none" }}
                    >
                        {service.map((service) => (
                            <MenuItem key={service.id} value={service.id} dir="ltr">
                                {service.service}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    sx={{
                        mt: 2,
                        padding: "10px",
                        borderRadius: "8px",
                        fontWeight: "bold",
                        backgroundColor: "var(--pri-col)", 
                        color: "white", 
                        "&:hover": {
                            backgroundColor: "var(--pri-col)", 
                            color: "white", 
                        },
                    }}
                    disabled={!formData.unit_id}
                >
                    Submit
                </Button>
            </form>
        </Container>
    );
}

